import axios from 'axios';

export const EXPIRY_SECONDS = 10 * 60;

export interface PutSecretResponse {
  message: string;
  id: string;
}

export interface GetSecretResponse {
  description: string;
  message: string;
  secretFound: boolean;
}

export async function putSecret(secret: string): Promise<PutSecretResponse> {
  const { data } = await axios.post<PutSecretResponse>('/api/put', { secret });
  return data;
}

export async function getSecret(id: string): Promise<GetSecretResponse> {
  const { data } = await axios.get<GetSecretResponse>(`/api/get/${id}`);
  return data;
}
